'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.STOREFRONT_KEY = exports.EVENT_NAMES = exports.createSelectors = exports.createContext = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _freeze = require('babel-runtime/core-js/object/freeze');

var _freeze2 = _interopRequireDefault(_freeze);

var _functional = require('../utils/functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var createContext = exports.createContext = function createContext(el) {
  var context = { context: el };

  return (0, _freeze2.default)({
    className: el.dataset.moduleClass,
    getElement: function getElement(selector) {
      return (0, _functional.getElement)(selector, context);
    },
    getElements: function getElements(selector) {
      return (0, _functional.getElements)(selector, context);
    }
  });
};

var createSelectors = exports.createSelectors = function createSelectors(_ref) {
  var selectors = _ref.selectors,
      context = _ref.context;
  return (0, _entries2.default)(selectors).reduce(function (acc, _ref2) {
    var _ref3 = (0, _slicedToArray3.default)(_ref2, 2),
        key = _ref3[0],
        value = _ref3[1];

    acc[key] = '.' + context.className + '_' + value;

    return acc;
  }, {});
};

var EVENT_NAMES = exports.EVENT_NAMES = {
  SEARCH_TRIGGER_CLICK: 'BAO::Search::TriggerClick'
};

var STOREFRONT_KEY = exports.STOREFRONT_KEY = window.theme.frontEndKey;